import { ScrollBarStyles } from 'src/components/Core/Styles/general-utilities'
import Flex from 'src/components/Layout/Flex/Flex'
import { Section } from 'src/components/Layout/Section/Section'
import styled from 'styled-components'

const TITLE_HEIGHT = 112
const BUTTON_MAX_HEIGHT = 54
const MARGIN = 24
const LINE = 1

export const CommentsPageWrapper = styled(Flex)`
    height: auto;
`

export const TitleSection = styled(Section)`
    height: ${TITLE_HEIGHT}px;
    margin: 0 0 24px 0;
    padding: 0;
`

export const CommentsSection = styled(Section)`
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: calc(100vh - 98px - 224px - ${TITLE_HEIGHT + LINE + MARGIN }px - ${BUTTON_MAX_HEIGHT + MARGIN + MARGIN }px);
    border-bottom: none;
    margin: 0;
    padding: 0;
    overflow-y: auto;
    box-shadow: -4px 3px 18px 0px ${props => props.theme.colors.shades.neutral[0]} inset;

    ${ScrollBarStyles}
`

export const DialogBoxWrapper = styled(Flex)`
    margin: 0;
`

export const DialogBox = styled(Flex)`
    width: 70%;
    padding: 16px;
`

export const FileDownloadWrapper = styled(Flex)`
    margin: 8px 0 16px 0;
    border: 2px ${props => props.theme.colors.shades.neutral[1]} solid;
    border-radius: 4px;
    padding: 8px 8px 8px 12px;

    &:hover {
      cursor: pointer;
    }
`

export const ContentBox = styled(Flex)<{bgColor?: string;}>`
    padding: 16px;
    border-radius: 4px;
    border: 1px ${props => props.theme.colors.shades.neutral[1]} solid;
    background-color: ${props => props.theme.colors.shades.neutral[`${props.bgColor}`]};
`

export const TextInputWrapper = styled(Flex)`
  position: relative;
  width: 90%;
  height: auto;
  border: 1px ${props => props.theme.colors.shades.neutral[1]} solid;

  & > svg {
      position: absolute;
      top: 8px;
      left: 12px;
      z-index: 1;
  }
`

export const InputAndButtonSection = styled(Section)`
    flex-direction: row;
    width: 100%;
    padding: 0;
    border-bottom: none;
`

export const FileNameAndInput = styled(Flex)`
    margin: 0 0 0 48px;

    label {
        width: auto;
    }

    textarea {
        font-size: 14px;
        width: 100%;
        height: 48px;
        min-height: 48px;
        border: none;

        &:hover, &:focus {
            border: none;
        }
    }
`

export const FileNameStyle = styled(Flex)`
    border: 1px ${props => props.theme.colors.shades.neutral[0]} solid;
    margin: 8px 0 0 10px;
    padding: 4px;

    svg {
        position: relative;
    }
`

export const InputStyle = styled.input`
    display: none;
    appearence: none;
`

export const SendButtonWrapper = styled(Flex)`
  width: 10%;
  align-self: stretch;
  align-items: center;
  background-color: ${props => props.theme.colors.main.backgroundDark};
  max-height: ${BUTTON_MAX_HEIGHT}px;

  &:hover, p:hover {
    cursor: pointer;
  }
`

